import { render, staticRenderFns } from "./CommunityCollaborators.vue?vue&type=template&id=ea2472b6&scoped=true&"
import script from "./CommunityCollaborators.vue?vue&type=script&lang=js&"
export * from "./CommunityCollaborators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2472b6",
  null
  
)

export default component.exports